
































































































import Vue from 'vue'
import Component from 'vue-class-component'
import TableBasedView from "@/components/TableBasedView.vue"
import Http from "@/Http"
import {Check, Content, VData} from "@/Models"
import Rules from "@/Rules"
import {vxm} from "@/Store"

@Component({components: {TableBasedView}})
export default class Checks extends Vue {

  currentDate = new Date()
  currentTs = this.currentDate.getFullYear() * 10000 + (this.currentDate.getMonth() + 1) * 100 + this.currentDate.getDate()

  headers = [
    {text: 'Name', align: 'start', sortable: true, value: 'custom2', width: '60%'},
    {text: 'WaitUser', align: 'center', sortable: false, value: 'waitUser', width: '15%'},
    {text: 'WaitAll', align: 'center', sortable: false, value: 'waitAll', width: '15%'},
    {text: 'Private', align: 'start', sortable: false, value: 'private', width: '15%'},
    {text: 'Actions', align: 'center', value: 'actions', sortable: false}
  ]

  date1 = false
  date2 = false
  store = vxm.app
  defaultItem = new Check()
  rules = new Rules()
  http = new Http()
  loading = true
  loadingError = false
  vdata: VData = new VData()

  isValid(item: Content): boolean {
    let from = parseInt(item.validityFrom.replaceAll("-", ""))
    let to = parseInt(item.validityTo.replaceAll("-", ""))
    return (from < this.currentTs && to > this.currentTs)
  }

  created() {
    this.loadData()
  }

  loadData() {
    this.loading = true
    this.loadingError = false
    this.http.apiGet<VData>(
        "data",
        (value) => {
          this.vdata = value
        },
        (wasError) => {
          this.finishLoading(wasError)
        }
    )
  }

  finishLoading(wasError: boolean) {
    this.$nextTick(() => {
      this.loading = false
      this.loadingError = wasError
    })
  }

  openUrl(url: string) {
    window.open(url, '_blank');
  }

  add1Y(validity: string): string {
    const parts: string[] = validity.split("-");
    return (parseInt(parts[0]) + 1) + "-" + parts[1] + "-" + parts[2];
  }

}
